import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog, MatDialogRef } from '@angular/material/dialog'

import { VehService } from '../services/vehicles/veh.service';
import { DialogVehicles } from '../dialog/vehicles/dialog.component.veh';
import { ListService } from '../list.service';
import { saveAs } from 'file-saver';

import { IVehicles, IVehiclesResponse } from './veh.interfaces';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StripHtmlPipe } from '../pipes/stripHTMLpipe';

@Component({
  selector: 'mcrit-gestio-vehicles',
  templateUrl: './veh.component.html',
  styleUrls: ['./veh.component.css'],
  providers: [StripHtmlPipe, VehService, ListService]
})
export class VehiclesComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public vehiclesData: IVehiclesResponse;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private vehModel: IVehicles = {
      'plate': 'NEW',
      'category': '',
      'manufacturer': '',
      'model': '',
      'year_manufacture': null,
      'colour': '',
      'fuel': '',
      'engine': '',
      'vin': '',
      'engine_num': '',
      'battery_num': '',
      'subcategory': '',
      'cc': '',
      'wheels_num': '',
      'passenger_num': '',
      'length':''
  };
  public error: string = '';
  public showDialog: boolean = false;
  public editVehicleData: IVehicles;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  public addVehicle(): void {
    this.editVehicleData = Object.assign( {}, this.vehModel, { id : 'NEW' } );
    let dialogFactRef=this.dialog.open(DialogVehicles, {disableClose: true, width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh', data: {dades: this.editVehicleData, user: this.userInfo} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editVehicleData = results;
      this.addOrUpdate();
    });
  }

  public editVehicle(vehicle: IVehicles): void {
    this.editVehicleData = Object.assign( {}, this.vehModel, vehicle );
    let dialogFactRef=this.dialog.open(DialogVehicles, {width: '85vw', height: '85vh',  maxWidth: '95vw',  maxHeight: '95vh', data: {dades: this.editVehicleData, user: this.userInfo} })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editVehicleData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editVehicleData.plate === 'NEW') {
      this.vehService.create(this.editVehicleData)
        .subscribe(newContacte => {console.log("S'ha creat l'element");this.router.navigate(['vehicles']);});
    } else {
      this.vehService.update(<number> this.editVehicleData.plate, this.editVehicleData)
        .subscribe(updatedContacte => {console.log("S'han desat les dades");this.router.navigate(['vehicles']);});
        //Actualitza la llista amb les modificacions
        let updateItem = this.vehiclesData.rows.find(item => item.plate == this.editVehicleData.plate);
        let index = this.vehiclesData.rows.indexOf(updateItem);
        this.vehiclesData.rows[index] = this.editVehicleData;
    }
  }

  public gotoPage(page: number): void {
    this.listVehService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    if(this.currentOrdering.length == 0)['nom'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listVehService.currentPage * this.listVehService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listVehService.currentPage * this.listVehService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listVehService.rowsPerPage - 1, this.vehiclesData.registers);
  }

  private requestRowsToParent(): void {
   if (this.path === 'vehicles') {
    this.vehService.getList(
      this.listVehService.rowsPerPage, //Limit
      this.listVehService.currentPage*this.listVehService.rowsPerPage, //Skip
      this.activeFilters //FILTRE DELS VEHICLES QUE ES MOSTREN A INICI
      ,{}//Conds a aplicar. Per defecte LIKE %%
      ,this.currentOrdering //ORDRE DELS VEHICLES QUE ES MOSTREN A INICI
      ,this.export
    ).subscribe(
      data => {
        if(!this.export){this.vehiclesData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
   }
   if (this.path === 'vehiclesinv') {
    let id
    this.route.paramMap.subscribe(params => {
      id = params.get('id');
      console.log(id);
    });
    this.vehService.getListVehAcc(id).subscribe(
      data => {
        if(!this.export){this.vehiclesData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
   }
  }

  public requestPrevious(): void {
     this.listVehService.currentPage = Math.max(0, this.listVehService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public requestNext(): void {
     this.listVehService.currentPage = this.listVehService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
  }

  public setRowPerPage(rowsPerPage: number) {
     this.listVehService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
  }

  public vehiclesFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>
  private path: string

  constructor(public striphtml:StripHtmlPipe, public tokenStorage: TokenStorageService, public listVehService: ListService, public dialog:MatDialog, private vehService: VehService, private router: Router, private route: ActivatedRoute) {
  this.userInfo = this.tokenStorage.getUser();}

  ngOnInit() {
    this.route.url.subscribe(segments => {
      this.path = segments[0]?.path;
    });
    this.ordreCamps = ['plate'];
    this.tableFields = [
      ['plate', 'Plate'],
      ['category', 'Category'],
      ['manufacturer', 'Manufacturer'],
      ['model', 'Model'],
      ['colour', 'Color'],
      ['year_manufacture', 'Year manufacture'],
      ['fuel', 'Fuel']
    ];

    this.vehiclesFilters = [
    {
      inputs: []
    },
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
              {
                text: 'Plate',//Text a mostrar label
                name: 'plate',//Camp de la base de dades
                autocomplete: 'plate',//Crida per obtenir els valors si autocomplete
                value: this.listVehService.getSearchValues('text')//valor a mostrar
              },
              {
                text: 'Category',
                name: 'category',
                autocomplete: 'category',
                value: this.listVehService.getSearchValues('text')
              },
              {
                text: 'Manufacturer',
                name: 'manufacturer',
                autocomplete: 'manufacturer',
                value: this.listVehService.getSearchValues('text')
              }
          ]
        }
      ]
    }
  ];

  this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
    ['plate'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);

    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.computeActiveFilters({ plate: id });
    } else {
      this.computeActiveFilters({});
    }
 
    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }

  ngOnDestroy(): void {
      this.unsubscriber.next();
      this.unsubscriber.complete();
  }

  go(lloc, id){this.router.navigate([lloc, id]);}

}
